export default {
  // Page titles
  campaigns: {
    title: 'Chiến Dịch SMS'
  },
  automation: {
    title: 'Tự Động Hóa SMS',
    ndc: 'Đăng Ký Chưa Nạp Tiền',
    inactive: 'Người Dùng Không Hoạt Động',
    churn: 'Người Dùng Rời Bỏ',
    welcome: 'SMS Chào Mừng',
    restorage: 'Nạp Lại Sau Lần Nạp Đầu',
    birthday: 'Nhắc Nhở Sinh Nhật',
    vip: 'Người Dùng VIP',
    allMembers: 'Tất cả thành viên'
  },
  vip: {
    title: 'Người Dùng SMS VIP'
  },

  // Task types
  type: {
    bulk: 'Gửi Hàng Loạt',
    ndc: 'Chưa Nạp Tiền',
    inactive: 'Không Hoạt Động',
    churn: 'Rời Bỏ',
    vip: 'Nhiệm Vụ VIP',
    welcome: 'SMS Chào Mừng',
    restorage: 'Nạp Lại Sau Lần Nạp Đầu',
    birthday: 'Nhắc Nhở Sinh Nhật',
    unknown: 'Không Xác Định'
  },

  // Form related
  form: {
    taskName: 'Tên Nhiệm Vụ',
    taskNamePlaceholder: 'Vui lòng nhập tên nhiệm vụ',
    country: 'Khu Vực',
    countryPlaceholder: 'Vui lòng chọn khu vực',
    vip: 'Cấp VIP',
    vipPlaceholder: 'Vui lòng chọn cấp VIP',
    status: 'Trạng Thái',
    statusPlaceholder: 'Vui lòng chọn trạng thái',
    template: 'Mẫu SMS',
    templatePlaceholder: 'Vui lòng chọn mẫu SMS',
    selectCategoryFirst: 'Vui lòng chọn danh mục mẫu trước',
    agent: 'Đại Lý',
    agentPlaceholder: 'Vui lòng nhập tên đại lý',
    haveLogin: 'Có Đăng Nhập',
    haveBet: 'Có Cược',
    inOut: 'Loại Người Dùng',
    inOutPlaceholder: 'Vui lòng chọn loại người dùng',
    sendTime: 'Thời Gian Gửi',
    sendTimePlaceholder: 'Vui lòng nhập giá trị',
    depositOrder: 'Thứ Tự Nạp Tiền',
    depositOrderPlaceholder: 'Vui lòng nhập số lần cụ thể, ví dụ 5',
    dailyPlaceholder: 'Vui lòng nhập số ngày',
    weeklyPlaceholder: 'Vui lòng nhập 1-7 (1=Thứ Hai, 7=Chủ Nhật)',
    monthlyPlaceholder: 'Vui lòng nhập 1-31 (ngày trong tháng)',
    timeUnit: 'Đơn Vị Thời Gian',
    templateContentPlaceholder: 'Vui lòng chọn mẫu trước',
    templateContent: 'Nội Dung Mẫu (Chỉ đọc)',
    importUsers: 'Nhập Người Dùng',
    importPhones: 'Nhập Số Điện Thoại',
    bulkSend: 'Gửi Hàng Loạt',
    selectFile: 'Chọn Tệp (CSV; dấu phẩy/khoảng trắng/xuống dòng; tự động loại bỏ trùng lặp)',
    chooseFile: 'Chọn Tệp',
    uploaded: 'Đã Tải Lên',
    notImported: 'Chưa Nhập',
    importUsersPlaceholder: 'Nhập tên người dùng (CSV; dấu phẩy/khoảng trắng/xuống dòng; tự động loại bỏ trùng lặp)',
    importPhonesPlaceholder: 'Nhập Số Điện Thoại (CSV; dấu phẩy/khoảng trắng/xuống dòng; tự động loại bỏ trùng lặp)'
  },

  // Upload related
  upload: {
    invalidFileType: 'Vui lòng tải lên tệp Excel liên quan (.xlsx, .xls, .xlsm, .xlsb, .csv, .txt)',
    success: 'Tải lên tệp Excel thành công',
    failed: 'Tải lên tệp Excel thất bại',
    error: 'Tải lên tệp Excel thất bại: {{error}}',
    pleaseUploadFirst: 'Vui lòng tải lên tệp Excel trước'
  },

  // User types
  inOut: {
    internal: 'Người Dùng Nội Bộ',
    external: 'Người Dùng Bên Ngoài'
  },

  // Time units
  timeUnit: {
    minutes: 'Phút',
    hours: 'Giờ',
    days: 'Ngày',
    weeks: 'Tuần',
    months: 'Tháng'
  },

  // Table related
  table: {
    taskName: 'Tên Nhiệm Vụ',
    template: 'Mẫu',
    country: 'Quốc Gia',
    vipLevel: 'Cấp VIP',
    sendTiming: 'Thời Gian Gửi',
    status: 'Trạng Thái',
    actions: 'Thao Tác',
    createUser: 'Người Tạo',
    createTime: 'Thời Gian Tạo',
    operator: 'Người Vận Hành',
    depositOrder: 'Thứ Tự Nạp Tiền',
    depositOrderValue: 'Lần nạp thứ {{times}}'
  },

  // Condition labels
  condition: {
    haveLogin: 'Có Đăng Nhập',
    haveBet: 'Có Cược'
  },

  // Status related
  status: {
    enabled: 'Kích Hoạt',
    disabled: 'Vô Hiệu Hóa'
  },

  // Button related
  button: {
    create: 'Tạo Nhiệm Vụ',
    execute: 'Thực Hiện Ngay',
    sendNow: 'Gửi Ngay',
    uploadFile: 'Tải Lên Tệp',
    createInternalCampaign: 'Tạo Chiến Dịch Người Dùng Nội Bộ',
    createExternalCampaign: 'Tạo Chiến Dịch Người Dùng Bên Ngoài',
    importLog: 'Nhật Ký Nhập'
  },

  // Modal related
  modal: {
    createTitle: 'Tạo Nhiệm Vụ SMS',
    editTitle: 'Chỉnh Sửa Nhiệm Vụ SMS',
    viewTitle: 'Xem Nhiệm Vụ SMS',
    importLogTitle: 'Nhật Ký Nhập Danh Sách',
    close: 'Đóng'
  },

  // Re-deposit task hint
  restorage: {
    hint: 'Người dùng đủ điều kiện: sau lần nạp thứ N không thực hiện nạp lại trong vòng 23 giờ sẽ nhận được SMS này.'
  },

  // Advanced filter
  advancedFilter: {
    title: 'Bộ Lọc Nâng Cao',
    excludeUser: 'Loại Trừ Người Dùng Trang Web Chính Thức',
    excludeAgent: 'Loại Trừ Người Dùng Đại Lý',
    excludeAgentWithHint: 'Loại Trừ Người Dùng Đại Lý (Có thể tìm kiếm, chọn nhiều)',
    selectAgents: 'Chọn Đại Lý Để Loại Trừ',
    selectAgentsPlaceholder: 'Vui lòng chọn đại lý (có thể tìm kiếm, chọn nhiều)',
    off: 'Tắt',
    on: 'Bật',
    excludeAllAgents: 'Loại Trừ Tất Cả Đại Lý',
    excludeSomeAgents: 'Loại Trừ Một Số Đại Lý',
    mobileValid: 'Người Dùng Đã Xác Thực Số Điện Thoại',
    // VIP task specific
    recentLoginPrefix: 'Chỉ gửi cho người dùng đã đăng nhập trong',
    recentLoginSuffix: 'ngày gần đây',
    recentLoginFullText: 'Chỉ gửi cho người dùng đã đăng nhập trong [] ngày gần đây',
    recentLoginTooltip: 'Hệ thống sẽ lọc người dùng có hồ sơ đăng nhập trong n ngày gần đây trước khi gửi (để trống nếu không giới hạn)',
    recentLoginDays: 'Người dùng đã đăng nhập trong {{days}} ngày'
  },

  // Validation related
  validation: {
    taskNameRequired: 'Vui lòng nhập tên nhiệm vụ',
    countryRequired: 'Vui lòng chọn quốc gia',
    templateRequired: 'Vui lòng chọn mẫu SMS',
    sendTimeRequired: 'Vui lòng nhập thời gian gửi',
    timeUnitRequired: 'Vui lòng chọn đơn vị thời gian',
    weeklyRangeError: 'Tần suất hàng tuần phải từ 1-7 (1=Thứ Hai, 7=Chủ Nhật)',
    monthlyRangeError: 'Ngày hàng tháng phải từ 1-31',
    agentRequired: 'Vui lòng chọn đại lý để loại trừ',
    recentDayRequired: 'Vui lòng nhập số ngày',
    recentDayRange: 'Số ngày phải từ 1-365',
    excludeUserAndAllAgentsConflict: 'Không thể chọn cả "Loại Trừ Người Dùng Trang Web Chính Thức" và "Loại Trừ Tất Cả Đại Lý" cùng lúc',
    excludeUserAndAllAgentsConflictSubmit: 'Không thể chọn cả "Loại Trừ Người Dùng Trang Web Chính Thức" và "Loại Trừ Tất Cả Đại Lý" cùng lúc, vui lòng chỉnh sửa trước khi gửi',
    depositOrderRequired: 'Vui lòng nhập thứ tự nạp tiền',
    depositOrderMin: 'Thứ tự nạp tiền phải tối thiểu là 1',
    sendTimeMinutesMax: 'Số phút không được vượt quá 4320',
    sendTimeHoursMax: 'Số giờ không được vượt quá 72 giờ',
    sendTimeDaysMax: 'Số ngày không được vượt quá 30 ngày'
  },

  // Message related
  message: {
    queryFailed: 'Truy vấn thất bại',
    createSuccess: 'Tạo thành công',
    createFailed: 'Tạo thất bại',
    updateSuccess: 'Cập nhật thành công',
    updateFailed: 'Cập nhật thất bại',
    deleteSuccess: 'Xóa thành công',
    deleteFailed: 'Xóa thất bại',
    statusUpdateSuccess: 'Cập nhật trạng thái thành công',
    statusUpdateFailed: 'Cập nhật trạng thái thất bại',
    executeSuccess: 'Thực hiện thành công',
    executeFailed: 'Thực hiện thất bại'
  },

  // Confirm related
  confirm: {
    delete: 'Bạn có chắc chắn muốn xóa nhiệm vụ này không?',
    toggleStatus: 'Bạn có chắc chắn muốn chuyển đổi trạng thái của nhiệm vụ này không?',
    execute: 'Bạn có chắc chắn muốn thực hiện nhiệm vụ này ngay lập tức không?',
    send: 'Bạn có chắc chắn muốn gửi nhiệm vụ này ngay lập tức không?'
  },

  // Pagination related
  pagination: {
    total: 'Tổng cộng {{total}} bản ghi'
  },

  // Import log
  importLog: {
    uploadFileStatus: {
      '80009001': 'Đang chờ',
      '80009002': 'Hoàn thành'
    },
    header: {
      taskName: 'Nhiệm vụ',
      importer: 'Người nhập',
      operator: 'Người vận hành',
      latestImportTime: 'Thời gian nhập gần nhất',
      importFileName: 'Tên tệp nhập',
      importCompleteTime: 'Thời gian hoàn thành nhập',
      importStatus: 'Trạng thái nhập'
    },
    stats: {
      success: 'Thành công',
      failed: 'Thất bại',
      total: 'Tổng cộng'
    },
    failureDetails: {
      title: 'Chi tiết thất bại',
      searchPlaceholder: 'Tìm kiếm tên người dùng thất bại',
      exportFailed: 'Xuất thất bại',
      memberAccount: 'Tài khoản thành viên',
      failureReason: 'Lý do thất bại',
      failureTime: 'Thời gian thất bại',
      rowNumber: 'Số dòng',
      remarks: 'Ghi chú',
      hint: 'Lưu ý: Chỉ giữ tài khoản người dùng thất bại trong một tháng',
      loading: 'Đang tải...',
      noFailedRecords: 'Không có bản ghi thất bại',
      noImportRecords: 'Chưa có bản ghi nhập',
      exportNotImplemented: 'Chức năng xuất chưa triển khai'
    }
  }
};
